import { render } from "./tips.vue?vue&type=template&id=6b0fb11a&scoped=true"
import script from "./tips.vue?vue&type=script&lang=js"
export * from "./tips.vue?vue&type=script&lang=js"

import "./tips.vue?vue&type=style&index=0&id=6b0fb11a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6b0fb11a"

export default script